import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'input[decimalNumbersOnlyMax]'
})
// tslint:disable-next-line:directive-class-suffix
export class DecimalNumbersMaxDirective{

  private el: NgControl;
  private maxlength: number;
  private lastDigit: number;

  constructor(private ngControl: NgControl) {
    this.el = ngControl;
  }
  @Input('decimalNumbersOnlyMax') maxValue: number;
  @Input() kommaStellen: number;

  // Listen for the input event to also handle copy and paste.
  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {

    value = value.replace(/[^0-9.]/g, '');

    this.lastDigit = this.maxValue.toString().length;

    // Checkt ob ein . falsch gesetzt ist oder ob es mehrere gibt
    if (value.includes('.')){
      // Erste Stelle des Strings kann kein Punkt sein
      if (value[0] === '.'){
        // Wegschneiden des Punktes
        value = value.substring(1);
      }
      else{
        // Checkt nach ungültigen Punkten ( Wenn die höchste eingegebene Zahl dreistellig ist kann kein Punkt an der fünften Stelle des Strings sein)
        for (let j = this.lastDigit + 1; j <= this.lastDigit + 1 + this.kommaStellen; j++){
          if (value[j] === '.'){
            value = value.slice(0 , j);
            break;
          }
        }
      }
      // Checkt ob es 2 Punkte in dem legitimen Bereich gibt. ( Beispiel 1..3 ) Alles hinter dem Ersten Punkt wird entfernt falls dies der Fall ist
      if ( value.indexOf('.') !== value.lastIndexOf('.')){
          value = value.slice(0, value.lastIndexOf('.'));
      }
    }

    // Ändert die Variabel maxLength je nachdem wie viele Stellen die Zahl haben darf. ( wird anhand von der Stelle des Kommas gecheckt / ob es überhaupt ein Komma besitzt
    this.findMaxLength(value, this.lastDigit, this.kommaStellen);
    // Use NgControl patchValue to prevent the issue on validation

    // falls der Zahl zu lange ist wird einfach die letzte Stelle weggeschnitten
    if ( value.length > this.maxlength){
      value = value.slice(0, -1);
      // Es kann passieren das die letzte Stelle weggeschnitten wird und dann ein Punkt zuhinterst ist. Falls dies der Fall ist wird der Punkt auch weggeschnitten
      if ( value[value.length - 1] === '.'){
        value = value.slice(0, -1);
      }
    }
    // Falls die Zahl zu hoch ist wird diese zugeschnitten
    if ( parseInt(value) > this.maxValue){
      value = value.slice(0, this.lastDigit - 1);
    }

    this.el.control.patchValue(value);
  }
  @HostListener('focusout', ['$event.target.value'])
  onBlur(value: string): void{
    if(value.length === 0){
      return;
    }

    value = (parseFloat(value).toFixed(this.kommaStellen)).toString();
    this.el.control.patchValue(value);
  }

  findMaxLength(value: string, maxDigits: number, maxKommastellen: number): void{
    // Falls die Höchste Zahl erreicht wurde darf nichts mehr hinten angehängt werden
    if(parseInt(value) == this.maxValue){
      this.maxlength = this.lastDigit;
      return;
    }
    // je nachdem an welcher Stelle der Punkt sich befindet wird die maximalLänge angepasst
    for (let i = 0; i < maxDigits + 1; i++){
        if (value[i] === '.'){
          this.maxlength = i + 1 + maxKommastellen;
          break;
        }
      // Falls kein Punkt sich in der Zahl befindet ist die maximal länge die höchste erlaubte Zahl + 1 wegen dem Punkt
        if ( i === maxDigits){
          this.maxlength = maxDigits + 1;
        }
    }
  }

}
